// extracted by mini-css-extract-plugin
export var floatingFooter = "FloatingFooter-module--floating-footer--2dh5n";
export var footerLinksItem = "FloatingFooter-module--footer-links-item--2eZRD";
export var phoneContact = "FloatingFooter-module--phone-contact--sI-GC";
export var blueFloatingFooter = "FloatingFooter-module--blue-floating-footer--s4E1r";
export var bluePhoneContactButton = "FloatingFooter-module--blue-phone-contact-button--1abNm";
export var bluePhoneContactButtonText = "FloatingFooter-module--blue-phone-contact-button-text--1t9Hc";
export var bluePhoneContactButtonLink = "FloatingFooter-module--blue-phone-contact-button-link--2YzzZ";
export var floatingContainer = "FloatingFooter-module--floating-container--3XNF8";
export var mobileCtaButton = "FloatingFooter-module--mobile-cta-button--2x61O";